import { maybeGetGlobal } from '../globals';
const X_WIX_BRAND_NAME = 'x-wix-brand';
export function xWixBrand() {
    const value = extractBrand();
    return { [X_WIX_BRAND_NAME]: value };
}
function extractBrand() {
    const globalObj = maybeGetGlobal();
    if (globalObj &&
        globalObj.commonConfig &&
        typeof globalObj.commonConfig.brand === 'string') {
        return globalObj.commonConfig.brand;
    }
    return '';
}
//# sourceMappingURL=x-wix-brand.js.map